import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import LoadsModal from "./Modals/LoadsModal";
import Rating from "../../../../components/Rating";

const LoadInfo = ({ orderDetail }) => {
  const userData = useSelector((state) => state.basicInfo.userDetails);
  const [openModal, setOpenModal] = React.useState(false);
  const handleOpen = () => setOpenModal(true);
  const handleClose = () => setOpenModal(false);

  return (
    <>
      <section id="user-loads-details">
        <div className="container theme-section">
          <div className="row user-loads-details-area">
            {userData?.user_type === "shipper" ? (
              <div className="col-lg-6">
                <div className="loader-user-info mb-5">
                  <div className="loader-user-img">
                    <img
                      src={orderDetail.carrier_obj?.profile_picture}
                      alt=""
                    />
                  </div>

                  <div>
                    <Link to={`/${orderDetail.carrier_obj?.user_id}/user-profile-information/`}>
                      <h1 className="large-text">
                        {orderDetail.carrier_obj?.name}
                      </h1>
                    </Link>
                    <div className="user-rating">
                      {!["", null, undefined].includes(
                        orderDetail?.carrier_obj?.avg_review_rating
                      ) && (
                        <Rating
                          rating={orderDetail?.carrier_obj?.avg_review_rating}
                        />
                      )}
                      <span>
                        ({orderDetail.carrier_obj?.avg_review_rating})
                      </span>
                    </div>
                  </div>
                </div>

                <div className="user-extra-info">
                  <div className="user-extra-info-box">
                    <span>Email:</span>
                    <span>{orderDetail.carrier_obj?.email}</span>
                  </div>
                  <div className="user-extra-info-box">
                    <span>Phone:</span>
                    <span>{orderDetail.carrier_obj?.phone_number}</span>
                  </div>
                  <div className="user-extra-info-box">
                    <span>Country:</span>
                    <span>{orderDetail.carrier_obj?.country}</span>
                  </div>
                  <div className="user-extra-info-box">
                    <span>State:</span>
                    <span>{orderDetail.carrier_obj?.state}</span>
                  </div>
                  <div className="user-extra-info-box">
                    <span>City:</span>
                    <span>{orderDetail.carrier_obj?.city}</span>
                  </div>
                  <div className="user-extra-info-box">
                    <span>Zip Code:</span>
                    <span>{orderDetail.carrier_obj?.zip_code}</span>
                  </div>
                  <div className="user-extra-info-box">
                    <span>Address:</span>
                    <span>{orderDetail.carrier_obj?.street_address}</span>
                  </div>
                </div>
              </div>
            ) : (
              <div className="col-lg-6">
                <div className="loader-user-info mb-5">
                  <div className="loader-user-img">
                    <img
                      src={orderDetail.shipper_obj?.profile_picture}
                      alt=""
                    />
                  </div>

                  <div>
                    <Link to={`/${orderDetail.shipper_obj?.user_id}/user-profile-information/`}>
                      <h1 className="large-text">
                        {orderDetail.shipper_obj?.name}
                      </h1>
                    </Link>
                    <div className="user-rating">
                      {!["", null, undefined].includes(
                        orderDetail?.shipper_obj?.avg_review_rating
                      ) && (
                        <Rating
                          rating={orderDetail?.shipper_obj?.avg_review_rating}
                        />
                      )}
                      <span>
                        ({orderDetail.shipper_obj?.avg_review_rating})
                      </span>
                    </div>
                  </div>
                </div>

                <div className="user-extra-info">
                  <div className="user-extra-info-box">
                    <span>Email:</span>
                    <span>{orderDetail.shipper_obj?.email}</span>
                  </div>
                  <div className="user-extra-info-box">
                    <span>Phone:</span>
                    <span>{orderDetail.shipper_obj?.phone_number}</span>
                  </div>
                  <div className="user-extra-info-box">
                    <span>Country:</span>
                    <span>{orderDetail.shipper_obj?.country}</span>
                  </div>
                  <div className="user-extra-info-box">
                    <span>State:</span>
                    <span>{orderDetail.shipper_obj?.state}</span>
                  </div>
                  <div className="user-extra-info-box">
                    <span>City:</span>
                    <span>{orderDetail.shipper_obj?.city}</span>
                  </div>
                  <div className="user-extra-info-box">
                    <span>Zip Code:</span>
                    <span>{orderDetail.shipper_obj?.zip_code}</span>
                  </div>
                  <div className="user-extra-info-box">
                    <span>Address:</span>
                    <span>{orderDetail.shipper_obj?.street_address}</span>
                  </div>
                </div>
              </div>
            )}

            <div className="col-lg-6">
              <h1 className="large-text mb-5">
                Total Amount: $ {orderDetail.amount}
              </h1>
              <div className="user-extra-info">
                <div className="user-extra-info-box">
                  <span>Origin Contact Name:</span>
                  <span>{orderDetail.load_post_obj?.origin_contact_name}</span>
                </div>
                <div className="user-extra-info-box">
                  <span>Origin Contact Phone Number:</span>
                  <span>
                    {orderDetail.load_post_obj?.origin_contact_phone_number}
                  </span>
                </div>
                <div className="user-extra-info-box">
                  <span>Origin Address:</span>
                  <span>{orderDetail.load_post_obj?.origin_address}</span>
                </div>
                <div className="user-extra-info-box">
                  <span>Destination Contact Name:</span>
                  <span>
                    {orderDetail.load_post_obj?.destination_contact_name}
                  </span>
                </div>
                <div className="user-extra-info-box">
                  <span>Destination Contact Phone Number:</span>
                  <span>
                    {
                      orderDetail.load_post_obj
                        ?.destination_contact_phone_number
                    }
                  </span>
                </div>
                <div className="user-extra-info-box">
                  <span>Destination Address:</span>
                  <span>{orderDetail.load_post_obj?.destination_address}</span>
                </div>
                <div className="user-extra-info-box">
                  <span>Pick Up Date:</span>
                  <span>{orderDetail.load_post_obj?.pickup_date}</span>
                </div>
                <div className="user-extra-info-box">
                  <span>Load Type:</span>
                  <span>{orderDetail.load_post_obj?.load_type_value}</span>
                </div>
                <div className="user-extra-info-box">
                  <span>Total Loads:</span>
                  <span>{orderDetail.total_loads}</span>
                </div>
                <div className="user-extra-info-box d-block">
                  <span>Additional Information</span>
                  <br />
                  <span>
                    {orderDetail.load_post_obj?.additional_information}
                  </span>
                </div>

                <button className="view-all-loads-btn" onClick={handleOpen}>
                  View All Loads
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <LoadsModal
        openModal={openModal}
        handleClose={handleClose}
        palletLoads={orderDetail.load_post_obj?.pallet}
        vehicleLoads={orderDetail.load_post_obj?.vehicle}
        barrelLoads={orderDetail.load_post_obj?.barrel}
        stonesLoads={orderDetail.load_post_obj?.stones}
        sandLoads={orderDetail.load_post_obj?.sand}
        lateriteLoads={orderDetail.load_post_obj?.laterite}
        loadType={orderDetail.load_post_obj?.load_type}
        totalLoad={orderDetail.total_loads}
      />
    </>
  );
};

export default LoadInfo;
